import React from "react";
import StatsContainer from "./StatsContainer";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Alert, AlertTitle } from "@material-ui/lab";

const StatsPage: React.FC<RouteComponentProps<{ id: string }>> = ({ match }) => {
    return <>
        <div style={{ marginTop: '32px' }}>
        <StatsContainer playerId={match.params.id}></StatsContainer>
        </div>
    </>
};

export default withRouter(StatsPage);